export default {"src":"/_next/static/media/pin-question-fill.975b2406.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};